






























































































































import { Component, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
const { VUE_APP_FCAPI: FCAPI } = process.env;
const dateFormat = require('bmh/date-format');
const getUrl = require('bmh/url-with-param');
import moment, { Moment } from 'moment';
const API: any = {
  query: `${FCAPI}/shang/promotion/bargain/spu`,
};

const ACTIVITY_STATUS = [
  {
    value: 0,
    label: '全部',
  },
  {
    value: 1,
    label: '未开始',
  },
  {
    value: 10,
    label: '进行中',
  },
  {
    value: 20,
    label: '已结束',
  },
];

interface TableDataItem {
  id: number;
  merchant_id: number;
  title: string;
  price: number;
  stock: number;
  invite_number: number;
  useful_life: number;
  start_time: number;
  end_time: number;
  rule_text: string;
  cardinal_number: number;
  multiple_number: number;
  create_time: number;
  update_time: number;
  ware_info: WareInfo;
  activity_status: number;
}

interface WareInfo {
  banner_url_list: string[];
  price: number;
}

interface QueryParams {
  title?: string;
  start_time?: number;
  end_time?: number;
  status?: number;
  current?: number;
  page?: number;
}

function getData(remote?: FcapiRemotePagination<any>) {
  remote = (remote || {}) as FcapiRemotePagination<any>;
  return {
    total: remote.total || 0,
    limit: remote.limit || 0,
    detail: remote.detail || [],
    last: remote.last || 0,
    current: +remote.current || 0,
  };
}

@Component
export default class Bargain extends Vue {
  activity_moment: Moment[] = [];
  activity_status: number = 0;
  bargain_title: string = '';
  current_page: number = 1;
  page: number = 1;
  form_item_layout: any = {
    labelCol: { span: 3 },
    wrapperCol: { span: 21 },
  };
  is_loading: boolean = false;
  is_show_promote_modal: boolean = false;
  table_data: FcapiRemotePagination<any> = getData();
  get activity_status_list() {
    return ACTIVITY_STATUS;
  }
  clearForm() {
    this.activity_moment = [];
    this.activity_status = 0;
    this.bargain_title = '';
    this.query();
  }
  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }

  paginationOption(data: any) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 1,
      current: data.current || 1,
    };
  }
  handChangePaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.page = next_page;
    this.query({
      page: this.page,
    });
  }
  async clickSeachBtn() {
    const query_params: QueryParams = {
      title: this.bargain_title,
      start_time: this.activity_moment[0]
        ? +this.activity_moment[0].format('X')
        : undefined,
      end_time: this.activity_moment[1]
        ? +this.activity_moment[1].format('X')
        : undefined,
      status: this.activity_status,
      current: this.current_page,
      page: this.page,
    };
    this.query(query_params);
  }

  async query(query_params?: QueryParams) {
    this.is_loading = true;
    this.table_data = getData();
    const url = getUrl(API.query, query_params);
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.table_data = getData(res.data.data);
    this.table_data.detail.forEach((item: TableDataItem) => {
      const nowtimestamp: number = ~~(+new Date() / 1000);
      if (item.start_time > nowtimestamp) {
        item.activity_status = 1;
      }
      item.activity_status =
        item.start_time > nowtimestamp
          ? 1
          : item.end_time < nowtimestamp
          ? 20
          : 10;
      console.log(item);
    });
    this.is_loading = false;
  }

  async created() {
    this.query();
  }
}
